/* OB gift ladder: keeps gift lines in step with the basket. Free pricing is done by the
   gift-ladder-discount Function; this file only adds, removes and reports. */
(function () {
  'use strict';

  var tag = document.currentScript;
  var configEl = document.getElementById('ObGiftLadderConfig');
  var cfg = {};
  try { cfg = JSON.parse(configEl.textContent) || {}; } catch (e) {}
  var tiers = cfg.tiers || [];
  var msgs = cfg.messages || {};
  var excl = cfg.exclude_from_subtotal || {};
  var exclTypes = (excl.product_types || []).map(function (s) { return String(s).toLowerCase(); });
  var exclIds = (excl.product_ids || []).map(num);

  var KEY = 'ob_gift_ladder';
  var store = {};
  try { store = JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch (e) {}
  store.added = store.added || {};     // tiers currently held in the cart
  store.dismissed = store.dismissed || {}; // removed by hand, stays out this session
  store.blocked = store.blocked || {}; // gift could not be free in this cart
  store.prompted = store.prompted || {}; // picker opened once automatically

  var busy = false, again = false, timer = null, selfWrite = 0;
  var pickerTier = null, pickerReady = null;
  var lastDetail = null, lastCart = null;
  var nativeFetch = window.fetch;

  function num(gid) { return Number(String(gid).split('/').pop()); }
  function save() { try { sessionStorage.setItem(KEY, JSON.stringify(store)); } catch (e) {} }
  function rate() { return Number(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1; }
  function live() {
    if (tag.dataset.on !== 'true' || !cfg.enabled) return false;
    var now = Date.now();
    if (cfg.starts_at && now < Date.parse(cfg.starts_at)) return false;
    if (cfg.ends_at && now > Date.parse(cfg.ends_at)) return false;
    return true;
  }
  function json(url, body) {
    var opts = { credentials: 'same-origin' };
    if (body) {
      opts.method = 'POST';
      opts.headers = { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
      opts.body = JSON.stringify(body);
    }
    return nativeFetch.call(window, url, opts).then(function (r) { return r.ok ? r.json() : null; });
  }
  function tierOf(item) { return item.properties && item.properties._ob_gift; }
  function subtotal(cart) {
    return cart.items.reduce(function (sum, item) {
      if (tierOf(item) || item.gift_card) return sum;
      if (exclTypes.indexOf(String(item.product_type || '').toLowerCase()) > -1) return sum;
      if (exclIds.indexOf(item.product_id) > -1) return sum;
      return sum + item.final_line_price;
    }, 0);
  }
  function threshold(tier) {
    var fixed = (tier.thresholds || {})[window.Shopify && Shopify.currency && Shopify.currency.active];
    return fixed ? Math.round(Number(fixed) * 100) : Math.round(Number(tier.threshold) * 100 * rate());
  }

  /* Stock checks run side by side and are kept for the page view; a failed add marks that variant out. */
  var stock = {};
  function inStock(gid) {
    var id = num(gid);
    if (!(id in stock)) stock[id] = json('/variants/' + id + '.js').then(function (v) { return !!(v && v.available); }, function () { return false; });
    return stock[id];
  }
  function firstAvailable(gids) {
    return Promise.all(gids.map(inStock)).then(function (ok) {
      var i = ok.indexOf(true);
      return i > -1 ? num(gids[i]) : null;
    });
  }
  /* Writes ask for the drawer back, so it is redrawn from the write itself instead of one more request. */
  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  function addGift(tier, variantId) {
    store.added[tier.id] = true;
    var properties = { _ob_gift: tier.id, _ob_gift_rule: cfg.rule_id || 'gift-ladder' };
    return json('/cart/add.js', { items: [{ id: variantId, quantity: 1, properties: properties }], sections: SECTIONS }).then(function (res) {
      if (!res) {
        delete store.added[tier.id]; // a failed add is not a shopper's removal
        stock[variantId] = Promise.resolve(false);
      }
      return res;
    });
  }
  function setQty(item, quantity) { return json('/cart/change.js', { id: item.key, quantity: quantity, sections: SECTIONS }); }

  function onCartPage() { return window.location.pathname.indexOf('/cart') > -1 && !!document.querySelector('cart-items'); }
  function refreshCart() {
    if (onCartPage()) {
      window.location.reload();
      return Promise.resolve();
    }
    return json('/?sections=' + SECTIONS).then(render);
  }
  function render(sections) {
    if (!sections || !sections['cart-drawer']) return;
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    /* The whole drawer, as the theme re-renders it: the bars and the empty state live outside the lines. */
    var from = doc.querySelector('.drawer__inner'), to = document.querySelector('cart-drawer .drawer__inner');
    var drawer = document.querySelector('cart-drawer'), fresh = doc.querySelector('cart-drawer');
    var empty = fresh && fresh.classList.contains('is-empty');
    /* The theme fills the shipping bar once by script, and a gift doesn't move it: keep the live one. */
    var bar = to && to.querySelector('.cart-countdown');
    if (from && to) to.innerHTML = from.innerHTML;
    var blank = to && to.querySelector('.cart-countdown');
    if (bar && blank && !empty) blank.replaceWith(bar);
    if (drawer && fresh) drawer.classList.toggle('is-empty', empty);
    var bubble = document.getElementById('cart-icon-bubble');
    var icon = new DOMParser().parseFromString(sections['cart-icon-bubble'] || '', 'text/html').querySelector('.shopify-section');
    if (bubble && icon) bubble.innerHTML = icon.innerHTML;
  }

  /* One pass: removals first (they can't fail on stock), then additions. */
  async function pass(cart) {
    var sub = subtotal(cart), writes = [], seen = {}, pick = null, nextChecked = false;

    cart.items.forEach(function (item) {
      var id = tierOf(item);
      if (!id) return;
      var tier = tiers.filter(function (t) { return t.id === id; })[0];
      var earned = tier && sub >= threshold(tier);
      if (!earned || seen[id]) {
        writes.push(function () { return setQty(item, 0); });
        if (!earned) delete store.added[id];
        return;
      }
      if (item.quantity > 1) {
        seen[id] = true;
        writes.push(function () { return setQty(item, 1); });
      } else if (item.final_line_price > 0 && cfg.guard !== false) {
        /* Another discount that won't combine has won: never leave a paid gift behind. */
        store.blocked[id] = true;
        delete store.added[id];
        writes.push(function () { return setQty(item, 0); });
      } else {
        seen[id] = true;
      }
    });

    for (var i = 0; i < tiers.length; i++) {
      var tier = tiers[i];
      if (sub < threshold(tier)) {
        /* Dropping below a tier resets it: earning it again offers the gift again. */
        delete store.blocked[tier.id];
        delete store.added[tier.id];
        delete store.dismissed[tier.id];
        delete store.prompted[tier.id];
        /* A tier with nothing left to give shouldn't be promised in the bar. */
        if (!nextChecked && tier.mode === 'auto' && !(tier.shelf_handles || []).length) {
          if (await firstAvailable((tier.primary || []).concat(tier.backup || []))) nextChecked = true;
          else store.blocked[tier.id] = 'soldout';
        } else {
          nextChecked = true;
        }
        continue;
      }
      if (seen[tier.id]) { store.added[tier.id] = true; continue; }
      if (store.added[tier.id]) { store.dismissed[tier.id] = true; delete store.added[tier.id]; }
      if (store.dismissed[tier.id] || store.blocked[tier.id]) continue;
      if (tier.mode === 'picker') { pick = pick || tier; continue; }
      var variant = await firstAvailable((tier.primary || []).concat(tier.backup || []));
      if (variant) writes.push(addGift.bind(null, tier, variant));
      else if ((tier.shelf_handles || []).length) pick = pick || tier;
      else store.blocked[tier.id] = 'soldout';
    }
    return { writes: writes, pick: pick, sub: sub };
  }

  function report(sub, pick) {
    var next = tiers.filter(function (t) { return sub < threshold(t) && !store.blocked[t.id]; })[0];
    var detail = {
      subtotal: sub,
      nextTier: next ? next.id : null,
      amountToNext: next ? threshold(next) - sub : 0,
      earned: tiers.filter(function (t) { return sub >= threshold(t); }).map(function (t) { return t.id; }),
      pending: pick ? pick.id : null,
      blocked: Object.keys(store.blocked).filter(function (id) { return store.blocked[id] === true; })
    };
    lastDetail = detail;
    window.dispatchEvent(new CustomEvent('ob:gift-ladder:update', { detail: detail }));
    note();
  }

  /* Reminder line in the drawer and on the cart page: a tier waits for a choice, was taken out, or couldn't be free. */
  function note() {
    markGiftLines();
    document.querySelectorAll('.ob-gift-note').forEach(function (el) { el.remove(); });
    if (!lastDetail) return;
    var tier = tiers.filter(function (t) {
      return lastDetail.earned.indexOf(t.id) > -1 && !store.added[t.id] && store.blocked[t.id] !== 'soldout';
    })[0];
    if (!tier) return;
    /* In the drawer it sits under the gift bar (which hides itself once every tier is earned, leaving the chip in its place). */
    var bar = document.querySelector('cart-drawer [data-bf26-ladder]');
    if (bar) bar.after(noteFor(tier));
    else {
      var foot = document.querySelector('cart-drawer .cart-drawer__express-pay') || document.querySelector('cart-drawer .drawer__footer-wrapper');
      if (foot) foot.parentNode.insertBefore(noteFor(tier), foot);
    }
    var page = document.querySelector('#main-cart-footer .cart__ctas');
    if (page) page.parentNode.insertBefore(noteFor(tier), page);
  }
  function noteFor(tier) {
    var p = document.createElement('p');
    p.className = 'cart-promo-nudge ob-gift-note';
    if (store.blocked[tier.id] === true) {
      p.textContent = msgs.blocked || 'Your free gift can’t be combined with this discount.';
      return p;
    }
    var link = document.createElement('a');
    link.href = '#';
    link.className = 'link';
    link.textContent = msgs.reminder || 'Add your free gift';
    link.addEventListener('click', function (e) {
      e.preventDefault();
      delete store.dismissed[tier.id];
      save();
      if (tier.mode === 'picker') openPicker(tier); else schedule(0);
    });
    p.appendChild(link);
    return p;
  }

  /* Gift quantity is always 1, so its lines lose the stepper. Delete stays. */
  function markGiftLines() {
    document.querySelectorAll('.ob-gift-line').forEach(function (el) { el.classList.remove('ob-gift-line'); });
    if (!lastCart) return;
    lastCart.items.forEach(function (item, i) {
      if (!tierOf(item)) return;
      ['CartDrawer-Item-', 'CartItem-'].forEach(function (prefix) {
        var row = document.getElementById(prefix + (i + 1));
        if (row) row.classList.add('ob-gift-line');
      });
    });
  }

  /* The theme fills the shipping bar on load and on 'rendered-cart', which its own drawer re-render fires.
     The quick-add re-renders the drawer without it (the picker's add on desktop), leaving the bar blank. */
  function fillShipping() {
    var caption = document.querySelector('cart-drawer:not(.is-empty) .counter__caption--above');
    if (!caption || caption.textContent.trim() || caption.dataset.obFill) return;
    caption.dataset.obFill = '';
    window.dispatchEvent(new CustomEvent('rendered-cart'));
  }

  async function run() {
    if (busy) { again = true; return; }
    busy = true;
    var wrote = false, drawn = false;
    try {
      for (var loop = 0; loop < 4; loop++) {
        var cart = await json('/cart.js');
        if (!cart) break;
        lastCart = cart;
        var writes;
        if (!live()) {
          writes = cart.items.filter(tierOf).map(function (item) { return setQty.bind(null, item, 0); });
        } else {
          var plan = await pass(cart);
          writes = plan.writes;
          if (!writes.length) {
            report(plan.sub, plan.pick);
            if (plan.pick && !store.prompted[plan.pick.id]) {
              store.prompted[plan.pick.id] = true;
              openPicker(plan.pick);
            }
          }
        }
        save();
        if (!writes.length) break;
        wrote = true;
        selfWrite++;
        var last = null;
        try {
          for (var i = 0; i < writes.length; i++) last = await writes[i]();
        } finally {
          selfWrite--;
        }
        /* Draw now; the next pass only confirms the cart. */
        drawn = !!(last && last.sections) && !onCartPage();
        if (drawn) { render(last.sections); note(); }
      }
      if (wrote && !drawn) await refreshCart();
      note();
      fillShipping();
    } catch (e) {}
    busy = false;
    if (again) { again = false; schedule(0); }
  }

  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(run, delay === undefined ? 50 : delay);
  }

  /* Picker: the theme's modal + cards, the quick-add panel does colour + size. Its add is caught
     below and given the gift properties, so that panel stays untouched. */
  function loadPicker() {
    if (pickerReady) return pickerReady;
    var ids = 'ob-gift-picker' + (document.getElementById('qaSheetCta') ? '' : ',collection-quick-cta-1-may');
    pickerReady = json('/?sections=' + ids).then(function (sections) {
      var box = document.createElement('div');
      box.innerHTML = sections['ob-gift-picker'] + (sections['collection-quick-cta-1-may'] || '');
      document.body.appendChild(box);
      box.querySelectorAll('script').forEach(function (old) {
        var s = document.createElement('script');
        s.textContent = old.textContent;
        old.replaceWith(s);
      });
      document.dispatchEvent(new CustomEvent('deferred-section:mounted'));
      var modal = document.getElementById('ObGiftPicker');
      modal.addEventListener('click', function (e) {
        if (e.target === modal) closePicker();
      });
      /* A card click would leave for the product page, where the piece is full price. */
      modal.addEventListener('click', function (e) {
        var card = e.target.closest('.card');
        if (!card || e.target.closest('.qa-overlay, .qa-mob-wrap, .qa-arrow, .qa-dots')) return;
        e.preventDefault();
        e.stopPropagation();
        var label = card.querySelector('.qa-overlay__label');
        if (label) label.textContent = msgs.size || 'Select Size';
        var plus = card.querySelector('.qa-mob[aria-label="Quick add to cart"]');
        if (plus) plus.click();
      }, true);
      /* The theme resets the shared mobile sheet's title on every open. */
      var title = document.getElementById('qaSheetTitle');
      if (title) new MutationObserver(function () {
        var want = msgs.size || 'Select Size';
        if (document.body.classList.contains('ob-gift-picking') && title.textContent !== want) title.textContent = want;
      }).observe(title, { childList: true });
      document.body.addEventListener('modalClosed', function () { pickerTier = null; document.body.classList.remove('ob-gift-picking'); });
      bindSheet();
      return modal;
    });
    return pickerReady;
  }
  /* Card images wait for a load-time observer that never sees injected nodes. */
  function showImages(modal) {
    modal.querySelectorAll('img[data-srcset]:not([src]), img[data-src]:not([src])').forEach(function (img) {
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      if (img.dataset.src) img.src = img.dataset.src;
      img.removeAttribute('loading');
    });
  }
  /* The sheet copies the card's price, so it says free too. */
  function showFree(modal) {
    modal.querySelectorAll('.card .price:not([data-ob-free])').forEach(function (price) {
      var shown = price.querySelector(price.classList.contains('price--on-sale') ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular');
      if (!shown) return;
      var was = document.createElement('s');
      was.textContent = shown.textContent.trim();
      var item = document.createElement('span');
      item.className = 'price-item price-item--regular';
      item.textContent = (msgs.free || 'Free') + ' ';
      item.appendChild(was);
      var box = document.createElement('div');
      box.className = 'price__regular';
      box.appendChild(item);
      price.classList.remove('price--on-sale');
      price.dataset.obFree = '';
      price.replaceChildren(box);
    });
  }
  /* The drawer sits above every modal, and can open just after the add that earned the tier. */
  function closeDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.classList.contains('active')) drawer.close();
  }
  /* Mobile: the sheet. Every row shows its sizes; one size across the sheet is chosen, and the button adds the gift itself. */
  var sheetTier = null;
  function bindSheet() {
    var sheet = document.getElementById('ObGiftSheet');
    if (!sheet) return;
    document.getElementById('ObGiftSheetBg').addEventListener('click', closeSheet);
    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-ob-gs-close]')) { closeSheet(); return; }
      var row = e.target.closest('[data-ob-gs-row]');
      var size = e.target.closest('.ob-gs__btn');
      var cta = row && row.querySelector('[data-ob-gs-cta]');
      if (size) {
        resetSheet(sheet);
        size.classList.add('ob-gs__btn--active');
        cta.dataset.variant = size.dataset.variant;
        cta.textContent = msgs.add || 'Add to cart';
        cta.classList.add('ob-gs__cta--ready');
        return;
      }
      if (e.target.closest('[data-ob-gs-cta]') && cta.dataset.variant && sheetTier) {
        var tier = sheetTier, status = row.querySelector('.ob-gs__status');
        cta.disabled = true;
        cta.textContent = msgs.adding || 'Adding to cart';
        addGift(tier, Number(cta.dataset.variant)).then(function (res) {
          save();
          if (!res) {
            cta.disabled = false;
            cta.textContent = msgs.add || 'Add to cart';
            status.textContent = msgs.error || 'Error, please try again';
            return;
          }
          closeSheet();
          (onCartPage() || !res.sections ? refreshCart() : Promise.resolve(render(res.sections))).then(function () {
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.open === 'function') drawer.open();
            schedule(0);
          });
        });
      }
    });
  }
  function resetSheet(sheet) {
    sheet.querySelectorAll('.ob-gs__btn--active').forEach(function (el) { el.classList.remove('ob-gs__btn--active'); });
    sheet.querySelectorAll('[data-ob-gs-cta]').forEach(function (cta) {
      var sized = !!cta.parentNode.querySelector('.ob-gs__btn');
      if (sized) { delete cta.dataset.variant; cta.classList.remove('ob-gs__cta--ready'); }
      cta.disabled = false;
      cta.textContent = sized ? (msgs.size || 'Select Size') : (msgs.add || 'Add to cart');
      cta.parentNode.querySelector('.ob-gs__status').textContent = '';
    });
  }
  function openSheet(tier) {
    var sheet = document.getElementById('ObGiftSheet'), bg = document.getElementById('ObGiftSheetBg');
    sheetTier = tier;
    sheet.querySelectorAll('[data-ob-gift-list]').forEach(function (el) { el.hidden = el.dataset.obGiftList !== tier.id; });
    resetSheet(sheet);
    sheet.scrollTop = 0;
    sheet.classList.add('ob-gs--open');
    bg.classList.add('ob-gs-bg--open');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('qa-sheet-lock'); // the quick-add sheet's class: hides the chat launchers over the button
    requestAnimationFrame(function () { requestAnimationFrame(function () { sheet.classList.add('ob-gs--in'); }); });
  }
  function closeSheet() {
    var sheet = document.getElementById('ObGiftSheet');
    if (!sheet || !sheet.classList.contains('ob-gs--open')) return;
    sheetTier = null;
    sheet.classList.remove('ob-gs--in');
    document.getElementById('ObGiftSheetBg').classList.remove('ob-gs-bg--open');
    document.body.style.overflow = '';
    document.body.classList.remove('qa-sheet-lock');
    setTimeout(function () { if (!sheetTier) sheet.classList.remove('ob-gs--open'); }, 300);
  }
  var mobile = window.matchMedia('(max-width: 749px)');

  function openPicker(tier) {
    json('/cart.js').then(function (cart) {
      var open = cart && subtotal(cart) >= threshold(tier) && !cart.items.some(function (item) { return tierOf(item) === tier.id; });
      if (!open) { schedule(0); return null; }
      return loadPicker();
    }).then(function (modal) {
      if (!modal) return;
      closeDrawer();
      if (mobile.matches && document.getElementById('ObGiftSheet')) {
        setTimeout(function () { if (sheetTier) closeDrawer(); }, 500);
        openSheet(tier);
        return;
      }
      setTimeout(function () { if (pickerTier) closeDrawer(); }, 500);
      pickerTier = tier;
      document.body.classList.add('ob-gift-picking');
      modal.querySelectorAll('[data-ob-gift-shelf]').forEach(function (el) {
        el.hidden = el.dataset.obGiftShelf !== tier.id;
      });
      modal.show();
      showImages(modal);
      showFree(modal);
      sizePicker(modal);
    }).catch(function () {});
  }
  /* Desktop layout inputs for the CSS in ob-gift-picker.liquid: rows/columns from the shelf's gift count
     (3 columns, then a second row) and the measured title block, so the cards are sized to fit the screen.
     Measured twice: the card width moves the title's line breaks, and that moves the height left for cards. */
  function sizePicker(modal) {
    var content = modal.querySelector('.quick-add-modal__content');
    var shelf = modal.querySelector('[data-ob-gift-shelf]:not([hidden])');
    if (!content || !shelf) return;
    var n = shelf.querySelectorAll('.grid__item').length || 1;
    content.style.setProperty('--ob-cols', Math.min(n, 3));
    content.style.setProperty('--ob-rows', Math.ceil(n / 3));
    for (var i = 0; i < 2; i++) {
      var title = shelf.querySelector('.ob-gift-title');
      if (title) {
        var block = title.getBoundingClientRect().height + parseFloat(getComputedStyle(title).marginBottom || 0);
        content.style.setProperty('--ob-head', Math.ceil(block) + 'px');
      }
      /* Everything under a card's image (name, price, the card wrapper's own space): measured on the tallest
         card, so a name that wraps to two lines is counted. */
      var text = 0;
      shelf.querySelectorAll('.grid__item').forEach(function (card) {
        var image = card.querySelector('.card__inner');
        if (image) text = Math.max(text, card.getBoundingClientRect().height - image.getBoundingClientRect().height);
      });
      if (text) content.style.setProperty('--ob-text', Math.ceil(text) + 'px');
    }
  }
  var resizing = 0;
  window.addEventListener('resize', function () {
    cancelAnimationFrame(resizing);
    resizing = requestAnimationFrame(function () {
      var modal = document.getElementById('ObGiftPicker');
      if (modal && modal.hasAttribute('open')) sizePicker(modal);
    });
  });
  function closePicker() {
    var modal = document.getElementById('ObGiftPicker');
    if (modal && modal.hasAttribute('open')) modal.hide();
    closeSheet();
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isCart = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
    if (pickerTier && /\/cart\/add(\.js)?(\?|$)/.test(url) && init && typeof init.body === 'string') {
      try {
        var body = JSON.parse(init.body);
        var tier = pickerTier;
        (body.items || [body]).forEach(function (item) {
          item.properties = Object.assign({}, item.properties, { _ob_gift: tier.id, _ob_gift_rule: cfg.rule_id || 'gift-ladder' });
        });
        init = Object.assign({}, init, { body: JSON.stringify(body) });
        store.added[tier.id] = true;
        save();
        closePicker();
      } catch (e) {}
    }
    var res = nativeFetch.call(window, input, init);
    if (isCart && !selfWrite) res.then(function () { schedule(); }).catch(function () {});
    return res;
  };

  document.addEventListener('cart:updated', function () { schedule(); });
  window.addEventListener('rendered-cart', function () { note(); schedule(); });

  var sig = tag.dataset.sig;
  var cartWithItems = onCartPage() && sig.split(':')[0] !== '0';
  if (tag.dataset.hasGift === 'true' || cartWithItems || (sig !== store.sig && sig.split(':')[0] !== '0')) schedule(0);
  store.sig = sig;
  save();
})();
